import { render, staticRenderFns } from "./MultiFactor.vue?vue&type=template&id=4a746801&"
import script from "./MultiFactor.vue?vue&type=script&lang=js&"
export * from "./MultiFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports